var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.hiddenHeader),expression:"!$route.meta.hiddenHeader"}]}),_c('router-view',{key:_vm.$route.fullPath}),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.meta.hiddenFooter),expression:"!$route.meta.hiddenFooter"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }